function getStoredCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function displayCookiesPopup(isCookieDate) {
  if(!isCookieDate) return;

  if (
    getStoredCookie(el.dataset.cookiesType) === undefined ||
    getStoredCookie(el.dataset.cookiesType) !== 'closed' ||
    el.dataset.mode === 'testing'
  ) {
    el.style.display = 'block';

    setTimeout(() => {
      el.classList.add('popup--animate');
    }, el.dataset.displayTime);
  }

  el.querySelector('.cookies-trigger').addEventListener('click', () => {
    el.classList.remove('popup--animate');

    setTimeout(() => {
      el.style.display = 'none';
    }, 100);

    if (el.dataset.mode === 'enabled') {
      document.cookie = `${el.dataset.cookiesType}=closed; path=/; max-age=${60 * 60 * 24 * el.dataset.cookies}`;
    }
  });
}

document.querySelectorAll('.cookies-popup').forEach((el) => {
  displayCookiesPopup(el.dataset.cookies);

  document.getElementById('cookiesTrigger').addEventListener('click', () => {
    el.style.display = 'block';
    el.showModal();
    setTimeout(() => {
      el.classList.add('popup--animate');    
    }, 100);    
  });

  el.querySelector('.cookies-trigger').addEventListener('click', () => {
    el.classList.remove('popup--animate');

    setTimeout(() => {
      el.style.display = 'none';
      el.close();
    }, 100);
  });
});
